import type { LocationQueryValue } from 'vue-router';

import { dashboard } from '../config/pages';

const stripProtocolAndDevPort = (value: string) => value
  .replace('http://', '')
  .replace('https://', '')
  .replace(':3000', '');

const getRedirectPathFromEncoded = (domain: string, encodedURL: string) => {
  const url = atob(encodedURL);
  const cleanUrl = stripProtocolAndDevPort(url);
  const cleanDomain = stripProtocolAndDevPort(domain);
  const directoryPath = cleanUrl.substring(0, cleanDomain.length);
  if (directoryPath === cleanDomain) {
    return cleanUrl.substring(cleanDomain.length);
  }
  return dashboard;
};

export const getRedirectPath = (
  appURL: string,
  encodedURL?: LocationQueryValue | LocationQueryValue[],
) => {
  if (encodedURL && typeof encodedURL === 'string' && encodedURL.length > 0) {
    try {
      return getRedirectPathFromEncoded(appURL, encodedURL);
    } catch (error) {
      if (error instanceof DOMException && error.message.indexOf('atob') !== -1) {

        console.info(error.message, encodedURL);
      } else {
        throw error;
      }
    }
  }
  return dashboard;
};
